import { db } from '../components/Dexie';
import { log } from './loggingService';

const API_BASE_URL = 'https://deadapi.techysumo.it';
const API_KEY = process.env.REACT_APP_API_KEY;

/**
 * Recupera i messaggi da Telegram e li salva in Dexie.
 * Se non ci sono messaggi in Dexie, scarica tutto.
 * Altrimenti, scarica solo i messaggi successivi all'ultimo salvato.
 * @returns {Promise<{success: boolean, count: number, error?: string}>}
 */
export const syncTelegramMessages = async () => {
  try {
    log("Avvio sincronizzazione messaggi Telegram...", 'INFO');

    // Trova l'ultimo messaggio salvato per ottenere la data dell'ultimo aggiornamento
    const lastMessage = await db.telegramMessages.orderBy('date').last();
    const lastUpdate = lastMessage ? lastMessage.date : null;

    const body = {};
    if (lastUpdate) {
      body.lastUpdate = lastUpdate;
    }

    const response = await fetch(`${API_BASE_URL}/telegram/listMessages`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': API_KEY,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`Errore API: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();

    if (result.result && Array.isArray(result.details)) {
      if (result.details.length > 0) {
        // Salvataggio massivo in Dexie
        // Usiamo put invece di add per evitare errori in caso di duplicati (se l'id è già presente)
        await db.telegramMessages.bulkPut(result.details);
        log(`Sincronizzati ${result.details.length} nuovi messaggi Telegram.`, 'INFO');
        return { success: true, count: result.details.length };
      } else {
        log("Nessun nuovo messaggio Telegram da sincronizzare.", 'INFO');
        return { success: true, count: 0 };
      }
    } else {
      log("Risposta API non valida o nessun dettaglio trovato.", 'WARNING');
      return { success: false, count: 0, error: 'Risposta API non valida' };
    }
  } catch (error) {
    log("Errore durante la sincronizzazione dei messaggi Telegram:", 'ERROR', error);
    return { success: false, count: 0, error: error.message };
  }
};
